import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-up",
  "use": "oc-up-usage",
  "viewBox": "0 0 1126 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1126 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-up\"><path d=\"M230.4 503.296a25.6 25.6 0 0 1-20.6848-40.8576L542.5152 10.5472a25.6 25.6 0 0 1 41.2672 0l332.8 451.8912a25.6 25.6 0 0 1-20.48 40.8576H659.0464V1024H467.3536V503.296H230.2976z\" p-id=\"20940\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol